export enum UploadType {
  Direct = "DIRECT",
  Transcoding = "TRANSCODING",
}
